// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class CallDetailRecordResource extends Resource {
    basePath: string = 'communication/phone/call-detail-records/';

    objectPath: string = 'communication/phone/call-detail-records/{ident}/';
    
    updateBySIPCallId = (sipId: UUID, data: Object) => this.client._request(
        // $FlowFixMe
        `${this._getObjectPath(sipId)}update_by_sip_call_id/`,
        'PUT',
        data,
    ).then((response) => response.data)
}
